import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { Baggage } from 'shared/models/ticket.ts'

import { Paper } from '../paper'

import styles from './styles.module.scss'

interface Props {
  flightCode?: string
  timeFlight?: string
  airplane?: string
  baggage?: Baggage
  cBaggage?: Baggage
}

export const FlightDetailsPopup: FC<Props> = (props) => {
  const { t } = useTranslation()

  const baggageText = props?.baggage?.weight
    ? t('detail_ticket.baggage_info', {
        count: props?.baggage?.piece,
        weight: props?.baggage?.weight,
      })
    : t('unknown')

  const cBaggageText = props?.cBaggage?.weight
    ? t('detail_ticket.baggage_info', {
        count: props?.cBaggage?.piece,
        weight: props?.cBaggage?.weight,
      })
    : t('unknown')

  return (
    <div className={styles.wrapper}>
      <Paper
        padding={[16]}
        radius={20}
      >
        <div className={styles.flight}>
          <h3>{props?.flightCode}</h3>

          <div className={styles.block}>
            <div className={styles.item}>
              <span>{t('departure_time')}</span>
              <p>{props?.timeFlight}</p>
            </div>

            <div className={styles.item}>
              <span>{t('airplane')}</span>
              <p>{props?.airplane}</p>
            </div>
          </div>
        </div>
      </Paper>

      <Paper
        padding={[16]}
        radius={20}
      >
        <div className={styles.flight}>
          <h3>{t('baggage')}</h3>

          <div className={styles.block}>
            <div className={styles.item}>
              <span>{t('baggage')}</span>
              <p>{baggageText}</p>
            </div>

            <div className={styles.item}>
              <span>{t('hand_baggage')}</span>
              <p>{cBaggageText}</p>
            </div>
          </div>
        </div>
      </Paper>
    </div>
  )
}
